import { render, staticRenderFns } from "./TheAcceptTermsAndConditions.vue?vue&type=template&id=1fa5c7bc&"
import script from "./TheAcceptTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./TheAcceptTermsAndConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports